import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type DeclaracaoSubstituicaoDiretorTecnicoPjJob = ReportJob;
export type DeclaracaoSubstituicaoDiretorTecnicoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Declaração de Substituição de Diretor Técnico. */
@Injectable({ providedIn: 'root' })
export class DeclaracaoSubstituicaoDiretorTecnicoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'declaracao-substituicao-diretor-tecnico-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.declaracaoSubstituicaoDiretorTecnicoPj;
}
